import React, { Component } from 'react';
import PropTypes from 'prop-types';

import './carouselNavButton.less';

class CarouselNavButton extends Component {
	render() {
		return (
			<button type="button" className="carousel-nav-button" {...this.props}>
				{this.props.children}
			</button>
		);
	}
}

CarouselNavButton.propTypes = {
	children: PropTypes.element,
	disabled: PropTypes.bool
}

export default CarouselNavButton;



// WEBPACK FOOTER //
// ./src/react/views/carousel/CarouselNavButton.jsx